import { Component, ContentChild, ElementRef, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'odq-navigation-step',
    templateUrl: './navigation-step.component.html',
    styleUrls: ['./navigation-step.component.scss'],
    standalone: false
})
export class NavigationStepComponent {

  @Input() showPreviousStep: boolean;
  @Input() showNextStep: boolean;
  @Input() disableButtons: boolean;
  @Output() onPreviousStep = new EventEmitter();
  @Output() onNextStep = new EventEmitter();

  @ContentChild('content') content: ElementRef;

  constructor(
  ) { }

  nextStep() {
    this.onNextStep.emit();
  }

  previousStep() {
    this.onPreviousStep.emit();
  }

}
